<template>
  <header>
    <!--Хедер десктопный-->
    <div class="header desktop">
      <div class="menu-btn" @click="showLeftMenu">
        <svg xmlns="http://www.w3.org/2000/svg" width="67" height="60"><path d="M47.562 20.829H19.438a.612.612 0 0 0 0 1.223h28.124a.612.612 0 0 0 0-1.223zM47.562 29.389H19.438a.612.612 0 0 0 0 1.222h28.124a.612.612 0 0 0 0-1.222zM47.562 37.948H19.438a.612.612 0 0 0 0 1.223h28.124a.612.612 0 0 0 0-1.223z" fill="#fff"/></svg>
      </div>
       <a class="logolink desktop" href="https://multiplex.ua">
          <img src="../assets/img/preloader_dt.svg" alt="loading..." style="position: absolute;">
        </a>
      <p class="cutted" @click="showLeftMenu">
        <span itemscope="" itemtype="http://data-vocabulary.org/Breadcrumb">
          <a itemprop="url" href="#" class="brcr_link">
            <span itemprop="title">{{ $t("header.heading") }}</span>
          </a>
        </span>
      </p>
        <div class="geo" v-if="user">
          <div class="profile">
            <!-- <div class="avatar" v-if="user"> -->
            <!-- <div class="avatar"> -->
              <!-- <div class="img_ava" :style="{ 'background-image': 'url(' + user.avatar + ')' }" v-if="user.avatar"></div> -->
              <!-- <div class="img_ava" v-else> -->
              <!-- <div class="img_ava">
                <img src="../assets/img/ava_temp.svg" alt="ava">
              </div> -->
            <!-- </div> -->
            <a class="header-logout" href="https://auth.multiplex.ua/logout">
              {{ $t("pop_ups.left_menu.logout") }}
              <span>
                <svg width="30" height="30" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M0 0h30v30H0z"/><path d="M15.064 9.614a1 1 0 0 0 .229 1.093L18.586 14H8a1 1 0 1 0 0 2h10.586l-3.293 3.293a1 1 0 1 0 1.414 1.414l4.912-4.912a1 1 0 0 0-.002-1.592l-4.91-4.91a1 1 0 0 0-1.643.321z" fill="#FFF" fill-rule="nonzero"/></g></svg>
              </span>
            </a>
          </div>
        </div>
    </div>
    
  
    <!--Мобильный хедер-->
    <div class="mobile_header">
      <a class="logo" href="https://multiplex.ua">
        <img src="../assets/img/preloader_dt.svg" alt="Multiplex">
      </a>
      <!-- <div class="hamb_holder mob-menu-btn" >
        <div class="hamburger">
          <span></span>
        </div>
      </div> -->
      
      <div class="mh_texts">
        <p class="top">{{ $t("header.heading") }}</p>
      </div>
    </div>
    <div id="nav-icon3" :class="{'open': mobMenuVisible}" @click="mobMenuVisible ? hideMobMenu() : showMobMenu()">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </header>
</template>
<script>
import Store from '../store'

export default {
  computed: {
    user: function () {
      return Store.state.user
    },
    mobMenuVisible: function () {
      return Store.state.mobMenuVisible
    }
  },
  methods: {
    showMobMenu: function () {
      Store.commit('showMobMenu')
    },
    hideMobMenu: function () {
      Store.commit('hideMobMenu')
    },
    showLeftMenu: function () {
      Store.commit('showLeftMenu')
    }
  }
}
</script>



// WEBPACK FOOTER //
// header.vue?34260bb8